import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=35a5f8eb&scoped=true&"
import script from "./DropdownMenu.vue?vue&type=script&lang=js&"
export * from "./DropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMenu.vue?vue&type=style&index=0&id=35a5f8eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a5f8eb",
  null
  
)

export default component.exports